export default __webpack_public_path__ + "static/media/schedule-flower-sep.79b15cb8.svg";